import type { ProFeature } from "./proFeatures.js";

/**
 * The words for each locked thing, used by the upgrade prompt and the locked pages. Plain words
 * that carry the meaning on their own (the owner is red-green colour blind): "part of Pro".
 */
export const PRO_COPY: Record<ProFeature | "profiles" | "playlists", { title: string; body: string }> = {
  catchup: {
    title: "Catch-up is part of Pro",
    body: "Replay programmes that already aired, on channels that keep an archive.",
  },
  recordings: {
    title: "Recording is part of Pro",
    body: "Record a programme or a whole series and watch it later.",
  },
  favorites: {
    title: "Favourites are part of Pro",
    body: "Keep your own list of channels, movies and series. What you saved before stays.",
  },
  phoneRemote: {
    title: "The phone remote is part of Pro",
    body: "Use a phone or tablet on your Wi-Fi as a remote and second screen.",
  },
  customRemote: {
    title: "Remote control settings are part of Pro",
    body: "Choose what each button on your remote does. The standard buttons keep working.",
  },
  timeshift: {
    title: "Pausing and rewinding live TV is part of Pro",
    body: "Pause, rewind and fast-forward live TV as you watch.",
  },
  multiview: {
    title: "Multiview is part of Pro",
    body: "Watch up to four channels at once.",
  },
  profiles: {
    title: "More profiles are part of Pro",
    body: "Free has one profile. Pro gives each person their own, up to five.",
  },
  playlists: {
    title: "More playlists are part of Pro",
    body: "Free has one playlist. Pro lets you add a backup or another server.",
  },
};
